import { SEO } from "../components/site/SEO";
import { PageHeader } from "../components/site/primitives";
import { Quality, Process } from "../components/site/Sections";

export default function AboutPage() {
  return (
    <>
      <SEO
        title="Quality, Service & How We Partner | Emporium London"
        description="How Emporium London delivers hospitality-grade quality at scale — dedicated account management, flexible volumes and coordinated delivery, with a clear five-stage partnership process."
        path="/about"
      />
      <main>
        <PageHeader
          overline="Quality &amp; Service"
          title="Hospitality-grade quality, managed end to end"
          intro="We supply groups that cannot compromise on consistency — every order specified, sampled, quality-controlled and delivered to every location in your estate."
        />
        <Quality />
        <Process />
      </main>
    </>
  );
}
